<template>
  <div id="hcpDownloads">
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div v-if="!isLoading">
      <p>Browse and download resources to support your patients</p>
      <mu-flexbox class="row" :gutter="16" v-for="chunks, index in chunkedItems" :key="'chunk-' + index">
        <mu-flexbox-item class="cat" v-for="cat, index in chunks" :key="'cat-' + index" :style="'background-image: url(' + cat.image + ');'">
          <mu-flexbox justify="flex-start" align="center" class="item">
            <mu-card @click.native="goTo(cat.slug)">
              <mu-card-text>
                <div class="cat-desc">
                  <h3 class="largeTitle">
                    <span v-once>{{cat.name}}</span>
                  </h3>
                  <div class="desc">
                    <div class="extract">
                      <div>{{cat.desc}}</div>
                    </div>
                    <span class="view-all">View All</span>
                  </div>
                </div>
              </mu-card-text>
            </mu-card>
          </mu-flexbox>
        </mu-flexbox-item>
      </mu-flexbox>
    </div>
  </div>
</template>
<script>
  import HcpApi from '../../api/Hcp'
  import _ from "lodash";
  import TitleManager from '../../helpers/TitleManager';

  export default {
    name: 'hcp-downloads',
    data () {
      return {
        isLoading: true,
        cats: [],
      }
    },
    methods: {
      getResources() {
        let self = this;
        HcpApi.getResourceCats().then(response => {
          self.cats = response.data;
          self.isLoading = false;
        });
      },
      initMounted() {
        let self = this;
        self.isLoading = true;
        self.getResources();
      },
      goTo(slug) {
        let self = this;
        self.$router.push({
          name: 'DownloadsCategory',
          params: {
            slug: slug
          }
        })
      }
    },
    computed: {
      chunkedItems () {
        let self = this;
        return _.chunk(_.toArray(self.cats), 2);
      }
    },
    mounted() {
      let self = this;
      TitleManager.replaceTitle("Resources");
      self.initMounted();
    }
  }
</script>

<style lang="less">
  #hcpDownloads {
    .cat {
      height: 260px;
      margin: 0 0 24px 0;
      background: no-repeat center center;
      background-size: cover;
      position: relative;
      border-radius: 2px;
      overflow: hidden;
      cursor: pointer;
      @media only screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0!important;
      }
      &:before {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(0, 0, 0, 0.75));
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .mu-card {
        display: flex;
        -webkit-align-items: flex-end;
        -moz-align-items: flex-end;
        align-items: flex-end;
        width: 100%;
        height: 100%;
        color: #FFF;
        background: none;
        box-shadow: none;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        .mu-card-text {
          width: 100%;
          padding-left: 20px;
          margin: 0 0 5px 0;
          color: #FFF;
        }
        .largeTitle {
          margin: 0 0 6px;
        }
        .desc {
          font-size: 15px;
          color: fade(#FFF, 60%);
        }
        .view-all {
          display: inline-block;
          margin: 12px 0 0;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          font-size: 12px;
          color: #FFF;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// HCPDownloads.vue?4b3b6e16